import { Component } from '@angular/core';
import { ModalService } from '../../../../../../../coverpath-common/angular/services/modal/modal.service';
import { AccountCenterService } from '../../../../../../../coverpath-common/angular/services/account-center/account-center.service';
import { AmorphicService } from '../../../../../../../coverpath-common/angular/services/amorphic/amorphic.service';
import { CoverpathUtils } from '../../../../../../../coverpath-common/js/static/CoverpathUtils';
import { CoverpathPolicyLinkConstructor } from '../../../../classes/policy-links/CoverpathPolicyLinkConstructor';
import { Controller } from '../../../../Controller';

@Component({
  selector: 'cancel-policy',
  moduleId: module.id,
  templateUrl: './cancel-policy.component.html',
})
export class CancelPolicyComponent {
  submitted: boolean = false;
  href: string = null;
  controller;

  constructor(
    private amorphicService: AmorphicService,
    private modalService: ModalService,
    private accountCenterService: AccountCenterService
  ) {
    this.controller = this.amorphicService.controller as Controller;
  }

  ngOnInit(): void {
    this.accountCenterService.workflowStateSubject.subscribe((workflowAction) => this.setCancelChoices(workflowAction));
  }

  setCancelChoices(workflowAction: string): void {
    if (/Cancel/.test(workflowAction)) {
      this.modalService.deactivate();
      return;
    }
    const isInForce = CoverpathUtils.isInForce(workflowAction);
    const isCollaterallyAssigned =
      this.accountCenterService.primaryPolicy.isCollaterallyAssigned() ||
      this.accountCenterService.primaryPolicy.isCollaterallyAssignedInsuredOtherThanOwner();
    const isNotFreeLook = !CoverpathUtils.isInFreeLook(workflowAction);
    const isJoint = this.accountCenterService.application.isJointApp();
    let showPowerForm = false;
    if (isInForce) {
      // if it is a joint or collatorally assigned app show the powerform
      // becuase there are complicatoins with cancelation for these types of
      // policies in all post issue stages
      if (isJoint || isCollaterallyAssigned) {
        showPowerForm = true;
        // if it is neither of the above only show the powerform if we are PAST freeLook
      } else if (isNotFreeLook) {
        showPowerForm = true;
      }
    }
    if (showPowerForm) {
      const isWholeLife = this.accountCenterService.primaryPolicy.isWholeLifePolicy();
      this.href = CoverpathPolicyLinkConstructor.createCancelViaDocusignLink(
        isWholeLife,
        this.controller.docusignClientCancelPowerFormId,
        this.controller.cpClientCancelTermPolicyPowerFormId
      );
    } else {
      this.href = null;
    }
  }

  // only in html if there is no this.href value
  cancelPolicy(): void {
    this.submitted = true;
    this.accountCenterService.cancelFromService();
  }

  closeModal(): void {
    this.modalService.deactivate();
  }
}
